import React from "react";
import "./index.css";
import App from "./App";
import { Provider as ReduxProvider } from "react-redux";
import createStore from "./store/create-store";
import { setAutoFreeze } from "immer";
import { createRoot } from "react-dom/client";

// redux.js toolkit uses immer to make state immutable
// but Plotly.js mutates state
// so we need to disable auto-freeze
setAutoFreeze(false);

const store = createStore();

const container = document.getElementById("root");

if (!container) {
  throw new Error("No root container found");
}

const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <ReduxProvider store={store}>
    <App />
  </ReduxProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
